import { render } from "./BoxWithStyle3.vue?vue&type=template&id=2e9f68c8&scoped=true"
import script from "./BoxWithStyle3.vue?vue&type=script&lang=js"
export * from "./BoxWithStyle3.vue?vue&type=script&lang=js"

import "./BoxWithStyle3.vue?vue&type=style&index=0&id=2e9f68c8&scoped=true&lang=css"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/wanfei-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9f68c8"]])

export default __exports__